import { useEffect, useState } from 'react';
import { getBuildingRaffle } from '~/api/building';

export default (buildingId: string) => {
  const [raffle, setRaffle] = useState<any>(null);

  const fetchRaffle = async () => {
    try {
      const { data } = await getBuildingRaffle(buildingId);

      setRaffle(data && data[0]);
    } catch (e) {}
  };

  useEffect(() => {
    fetchRaffle();
  }, []);

  return { raffle };
};
